'use strict';

var React = require('react');
require('prop-types');
var withStyles = require('../../../node_modules/@material-ui/core/styles/withStyles.js');
var LineItemHeader = require('./LineItemHeader.js');
var LineItemRow = require('./LineItemRow.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = {
  table: {
    width: '100%',
    tableLayout: 'fixed',
    borderCollapse: 'collapse'
  }
};

var LineItemsWeb = function LineItemsWeb(_ref) {
  var lineItems = _ref.lineItems,
      isMaterialItems = _ref.isMaterialItems,
      settings = _ref.settings,
      hasLineItemImages = _ref.hasLineItemImages,
      isPDF = _ref.isPDF,
      classes = _ref.classes;
  return React__default["default"].createElement("table", {
    className: classes.table
  }, React__default["default"].createElement("tbody", null, React__default["default"].createElement(LineItemHeader, {
    isMaterialItems: isMaterialItems,
    settings: settings
  }), lineItems.map(function (lineItem) {
    return React__default["default"].createElement(LineItemRow, {
      lineItem: lineItem,
      key: lineItem.id,
      settings: settings,
      hasLineItemImages: hasLineItemImages,
      isPDF: isPDF
    });
  })));
};

var LineItemsWeb$1 = withStyles(styles)(LineItemsWeb);
LineItemsWeb.defaultProps = {
  hasLineItemImages: false,
  isPDF: false
};

module.exports = LineItemsWeb$1;
